import React from 'react';
import UAParser from 'ua-parser-js';

// Component for detecting device information
const DeviceDetector = () => {
    // Variables to store device information
    let isType = null;
    let isBrowser = null;
    let isOs = null;
    let isEngine = null;

    // Create instance of UAParser
    const parser = new UAParser();
    const uaDevice = parser.getResult(); // Get parsed user agent information

    // Destructure parsed information
    const { browser, device, os, engine, ua } = uaDevice;

    // Check if user agent information is available
    if (uaDevice !== null && uaDevice !== undefined && uaDevice !== "") {
        // Check if device type is available
        if (device.type !== undefined && device.type !== null && device.type !== '') {
            isType = device.type;
            isOs = os.name;
            isBrowser = browser.name;
            isEngine = engine.name;
        } else {
            isType = 'Desktop';
            isOs = os.name;
            isBrowser = browser.name;
        }
    } else {
        // Set defaults for unknown device
        isOs = "Unknown";
        isBrowser = browser.name;
        isType = device.type;
    }

    // Return device information
    return { isOs, isBrowser, isType, isEngine, ua };
}

export default DeviceDetector;
